<template>
  <div class="pa-item-list-item" @click.prevent="toggleOpen" v-if="hasItem">
    <transition name="pa-item-list-item-image-box">
      <div class="image-box" v-if="isOpenWidely">
        {{characterItemStore.item.slug}}
      </div>
    </transition>

    <div class="column-key">
      <p>{{characterItemStore.item.name}}</p>
    </div>
    <div class="column-value">
      <p>x{{characterItemStore.quantity}}</p>
    </div>
    
    <transition name="pa-item-list-item-image-box">
      <div class="item-description" v-if="isOpenWidely">
        <p>{{characterItemStore.item.description}}</p>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props : ['characterItemStore'],
  data(){
    return {
      allowToggleOpen : false,
      isOpenWidely    : false
    }
  },
  computed : {
    hasItem(){
      if(this.characterItemStore.quantity === 0){
        return false;
      }else{
        return true;
      }
    }
  },
  methods : {
    toggleOpen(){
      if(!this.allowToggleOpen) return;

      this.isOpenWidely = !this.isOpenWidely;
    }
  }
}
</script>

<style lang="scss">
.pa-item-list-item-image-box{
  &-enter-active{
    animation: simpleFadeIn .5s;
  }

  &-leave-active{
    animation: simpleFadeIn .15s reverse;
  }

  &-enter, &-leave-to{
    opacity:0;
  }
}
.pa-item-list-item{
  color:#726047;
  background-color:#B78660;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;

  div.image-box{
    width:100%;
    height:80px;
    background-color: #BE8B64;
    margin:.25rem .25rem 0;
    border-radius: 5px;
  }
  
  > div.column-key{
    margin:0;
    padding:0;
    width:80%;

    p{
      padding:0 .2rem;
    }
  }

  > div.column-value{
    margin:0;
    padding:0;
    width:20%;
    text-align: right;
    
    p{
      padding:0 .2rem;
    }
  }

  div.item-description{
    width:98%;
    border-top:2px solid #BC9173;
    color:#726047;
    padding:.2rem;
    > p{
      font-size: .7rem;
    }
  }
}
</style>